import { Component, input } from '@angular/core';
import { MtrFormFieldModule } from '@mortar/angular/components/atomic/form-field';
import { MtrInputModule } from '@mortar/angular/components/atomic/input';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { InputComponent } from 'app/driver-pay/persistence/core/components/inputs/InputComponent';

@Component({
  selector: 'date-input',
  standalone: true,
  template: `
    <mtr-form-field>
      <input
        #inputElement
        mtr-input
        id="{{ id() }}"
        [formControl]="inputFormControl()"
        type="date"
        [max]="max()"
        (change)="handleChange()" />
    </mtr-form-field>
  `,
  imports: [MtrFormFieldModule, MtrInputModule, FormsModule, ReactiveFormsModule],
})
export class DateInputComponent implements InputComponent {
  inputFormControl = input.required<FormControl<string | null>>();
  id = input.required<string>();
  max = input<string | undefined>();
  handleChange() {
    if (this.inputFormControl().getRawValue() === '') {
      this.inputFormControl().setValue(null);
    }
  }
}
